export const stores = [
    { 
        name: 'signin',
        path: '/users/signin',
    },
    { 
        name: 'me',
        path: '/auth/me',
    },
    { 
        name: 'register',
        path: '/users/signup',
    },
    { 
        name: 'users',
        path: '/users/all-users',
    },
    {
        name: 'get-user-by-email',
        path: '/users/user-request-by-email',
    },
    {
        name: 'change-user-password',
        path: '/users/change-user-password',
    },
    {
        name: 'update-user-details',
        path: '/users/update-user-details',
    },
    {
        name: 'livelihoodzones',
        path: '/livelihoodzones/all-livelihoodzones',
    },
    {
        name: 'livelihoodzones-search-sub-locations',
        path: '/livelihoodzones/search_sublocation_by_name_and_county_id',
    },
    {
        name: 'update-sub-location-livelihoodzone',
        path: '/livelihoodzones/update_a_sublocation_livelihood_zone',
    },
    {
        name: 'county-livelihoodzones',
        path: '/livelihoodzones/county-livelihoodzones/',
    },
    {
        name: 'update-county-livelihoodzones',
        path: '/livelihoodzones/update-county-livelihoodzones',
    },
    {
        name: 'livelihoodzone-by-county',
        path: '/livelihoodzones/a-county-livelihoodzone-information',
    },
    // reports
    {
        name: 'livestock-types',
        path: '/wealthgroup-reports/all-livestock-types',
    },
    {
        name: 'income-sources',
        path: '/wealthgroup-reports/all-cash-income-sources',
    },
    {
        name: 'crops',
        path: '/wealthgroup-reports/all-crops',
    },
    {
        name: 'crop-contribution-aspects',
        path: '/wealthgroup-reports/crop-contribution-aspects'
    },
    {
        name: 'migration-patterns',
        path: '/wealthgroup-reports/all-migration-patterns',
    },
    {
        name: 'water-sources',
        path: '/zone-level-reports/all-water-sources'
    },
    {
        name: 'seasons-types',
        path: '/zone-level-reports/all-seasons-types',
    },
    {
        name: 'hazards',
        path: '/zone-level-reports/all-hazards',
    },
    {
        name: 'hazard-aspects',
        path: '/zone-level-reports/hazard-aspects',
    },
    {
        name: 'rainy-seasons',
        path: '/zone-level-reports/all-rainy-seasons',
    },
    {
        name: 'wealthgroup-reports-by-livestock',
        path: '/wealthgroup-reports/charts/livestock-ownership-by-livestock',
    },
    {
        name: 'wealthgroup-reports-tlu',
        path: '/wealthgroup-reports/livestock-ownership/tlu',
    },
    {
        name: 'wealthgroup-tlu-bylivelihoodzone',
        path: '/wealthgroup-reports/tlu/byLivelihoodzone',
    },
    {
        name: 'zonelevel-hunger-patterns',
        path: '/zone-level-reports/maps/hunger-patterns',
    },
    {
        name: 'zonelevel-hazards',
        path: '/zone-level-reports/maps/hazards',
    },
    {
        name: 'zonelevel-population-distribution',
        path: '/zone-level-reports/maps/wealth-group-population-distribution',
    },
    {
        name: 'zonelevel-main-water-sources',
        path: '/zone-level-reports/maps/main-water-sources',
    },
    {
        name: 'wealthgroup-reports-income-sources-map-data',
        path: '/wealthgroup-reports/maps/income-sources-map-data',
    },
    {
        name: 'wealthgroup-reports-migration-patterns-map-data',
        path: '/wealthgroup-reports/maps/migration-patterns-map-data',
    },
    {
        name: 'wealthgroup-reports-crop-contribution-map-data',
        path: '/wealthgroup-reports/maps/crop-contribution-map-data',
    },
    {
        name: 'wealthgroup-reports-charts',
        path: '/wealthgroup-reports/charts',
    },
    {
        name: 'wealthgroup-reports-charts-by-livelihoodzone',
        path: '/wealthgroup-reports/charts/byLivelihoodzone', 
        // /wealthgroup-reports/charts/byLivelihoodzone
    },
    {
        name: 'zone-wealthgroup-distribution',
        path: '/wealthgroup-reports/zone-wealthgroup-distribution',
    },
    {
        name: 'wealthgroup-categories',
        path: '/wealthgroup-reports/wealth-group-categories',
    },
    // retrive responses
    {
        name: 'wealth-group-questionnaire-sections',
        path: '/responses/wealth-group-questionnaire-sections',
    },
    {
        name: 'wealth-group-responses',
        path: '/responses/wealthgroup/retrieve/',
    },
    {
        name: 'zone-level-questionnaire-sections',
        path: '/responses/zone-level-questionnaire-sections',
    },
    {
        name: 'zone-level-reports',
        path: '/zone-level-reports/zone-level-report',
    },
    {
        name: 'zone-level-charts',
        path: '/zone-level-reports/charts',
    },
    {
        name: 'zone-level-reports-export',
        path: '/zone-level-reports/export/excel'
    },
    {
        name: 'wealthgroup-aggregate-responses',
        path: '/wealthgroup-reports/wealthgroup-aggregate-responses',
    },
    {
        name: 'wealthgroup-questionnaire-types',
        path: '/wealthgroup-reports/wealth-group-questionnaire-types',
    },
    {
        name: 'wealthgroup-reports',
        path: '/wealthgroup-reports/zone-wealthgroup-distribution',
    },
    {
        name: 'county-responses',
        path: '/responses/county/retrieve/',
    },
    {
        name: 'wealth-group-questionnaire-id',
        path: '/responses/all-wealth-group-questionnaire-sessions',
    },
    {
        name: 'county-questionnaire-id',
        path: '/responses/all-zone-level-questionnaire-sessions',
    },
    {
        name: 'wealthgroup-distribution',
        path: '/wealthgroup-reports/zone-wealthgroup-distribution/',
    },
    { 
        name: 'roles',
        path: '/users/all-roles',
    },
    {
        name: 'counties',
        path: '/counties/all-counties',
    },
    {
        name: 'request-verification',
        path: '/authorization/users/resend_activation/',
    },
    {
        name: 'email-verification',
        path: '/authorization/users/activation/',
    },
    { 
        name: 'applications',
        path: '/applications/applications/',
    },
    {
        name: 'auto-create-application',
        path: '/applications/applications/auto_create/',
    },
    {
        name: 'attachments',
        path: '/common/attachments/',
    },
    {
        name: 'contacts',
        path: '/common/contacts/',
    },
    {
        name: 'contact-groups',
        path: '/common/contact-groups/',
    },
    {
        name: 'email-groups',
        path: '/common/email-groups/',
    },
    {
        name: 'news-letters',
        path: '/common/news-letters/',
    },
    {
        name: 'communications',
        path: '/common/communications/',
    },
    {
        name: 'application-activities',
        path: '/application/application_activities/',
    },
    {
        name: 'application-activity-allowances',
        path: '/applications/application_activity_allowances/',
    },
    {
        name: 'application-activity-items',
        path: '/applications/application_activity_items/',
    },
    {
        name: 'application-activity-attendees',
        path: '/applications/application_activity_items/',
    },
    {
        name: 'application-activity-mes',
        path: '/applications/application_activity_mes/',
    },
    {
        name: 'application-activity-attachments',
        path: '/applications/application_activity_attachments/',
    },
    { 
        name: 'application-items',
        path: '/applications/application_items/',
    },
    {
        name: 'application-allowances',
        path: '/applications/application_allowances/',
    },
    {
        name: 'application-mes',
        path: '/applications/application_mes/'
    },
    { 
        name: 'application-attendees',
        path: '/applications/application_items/',
    },
    { 
        name: 'application-alternate-funding-sources',
        path: '/applications/alternate_funding_sources/',
    },
    { 
        name: 'application-reviews',
        path: '/applications/application_reviews/',
    },
    { 
        name: 'application-review-attachments',
        path: '/applications/application_review_attachments/',
    },
    { 
        name: 'application-attachments',
        path: '/applications/application_attachments/',
    },
    { 
        name: 'organization-attachments',
        path: '/organizations/organization_attachments/',
    },
    {
        name: 'dashboard-data',
        path: '/applications/dashboard_counts/',
    },
    { 
        name: 'sports-events',
        path: '/common/sport_events/',
    },
    { 
        name: 'sports-categories',
        path: '/common/sport_categories/',
    },
    {
        name: 'billable-items',
        path: '/common/items/',
    },
    {
        name: 'allowances',
        path: '/common/allowances/',
    },
    { 
        name: 'document-types',
        path: '/applications/document_types/',
    },
    { 
        name: 'organizations',
        path: '/organizations/organizations/',
    },
    { 
        name: 'organization-financial-years',
        path: '/organizations/financial_years/',
    },
    { 
        name: 'organization-budgets',
        path: '/organizations/organization_budgets/',
    },
    { 
        name: 'organization-budget-activities',
        path: '/organizations/organization_budget_activities/',
    },
    {
        name: 'organization-budget-activity-items',
        path: '/organizations/organization_budget_activity_items/',
    },
    {
        name: 'organization-budget-activity-attendees',
        path: '/organizations/organization_budget_activity_items/',
    },
    {
        name: 'organization-budget-activity-allowances',
        path: '/organizations/organization_budget_activity_allowances/',
    },
    {
        name: 'organization-budget-activity-attachments',
        path: '/organizations/organization_budget_activity_attachments/',
    },
    {
        name: 'organization-budget-reviews',
        path: '/organizations/organization_budget_reviews/',
    },
    { 
        name: 'organization-budget-reviews',
        path: '/organizations/organization_budget_reviews/',
    },
    { 
        name: 'organization-budget-attachments',
        path: '/organizations/organization_budget_attachments/',
    },
    { 
        name: 'organization-roles',
        path: '/organizations/organization_roles/',
    },
    { 
        name: 'organization-members',
        path: '/organizations/organization_members/',
    },
    {
        name: 'organization-members-download-template',
        path: '/organizations/organization_members/download_template/'
    },
    {
        name: 'organization-members-upload-members',
        path: '/organizations/organization_members/upload_members/'
    },
    { 
        name: 'organization-types',
        path: '/organizations/organization_types/',
    },
    { 
        name: 'organization-roles',
        path: '/organizations/organization_roles/',
    },
    {
        name: 'user-groups',
        path: '/auth/groups/',
    },
    { 
        name: 'organization-bank-accounts',
        path: '/organizations/organization_bank_accounts/',
    },
    { 
        name: 'organization-financial-years',
        path: '/organizations/organization_financial_years/',
    },
    { 
        name: 'organization-join-requests',
        path: '/organizations/organization_join_requests/',
    },
    { 
        name: 'gallery',
        path: '/galleries',
    },
    {
        name: 'complaints',
        path: '/complaints/complaints/',
    },
    {
        name: 'complaint-reviews',
        path: '/complaints/complaint_reviews/',
    },
    {
        name: 'complaint-review-attachments',
        path: '/complaints/complaint_review_attachments/',
    }
]